export default __webpack_public_path__ + "static/media/3435 cutlery side.d136802d.png";